import MsLanguageResource from "./MsLanguageResource";

export default class MsLanguageResourceList {
  constructor(name, initialValue = [], namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.msLanguageResourceList = [];
    this.isEditor = isEditor;
    // console.log(name, initialValue);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.msLanguageResourceList;
  }

  setObjList(fmsLanguageResourceList) {
    this.msLanguageResourceList = fmsLanguageResourceList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.msLanguageResourceList.length) {
      return;
    }
    this.msLanguageResourceList.splice(index, 1);
  }

  addValueObj(obj) {
    // console.log(obj, this.name, this.namespace);
    const msLanguageResource = new MsLanguageResource(this.name, obj, this.namespace, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace, this.isEditor);
    this.msLanguageResourceList.push(msLanguageResource);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        // console.log(value, this.namespace);
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.msLanguageResourceList.length; index++) {
      const docItem = this.msLanguageResourceList[index];
      expandedList.push(docItem.getExpandedFormatValue());
    }
    // console.log(expandedList);
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.msLanguageResourceList.length; index++) {
      const docItem = this.msLanguageResourceList[index];
      condition = condition && docItem.isEmpty();
    }
    return condition;
  }
}
